function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import dateid from '@paperstac/common/lib/services/dateid';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Button from '../Button';
const handleChange = (_ref, onFiles) => {
  let {
    target: {
      files
    }
  } = _ref;
  onFiles && onFiles(files);
};
const FileInputButton = /*#__PURE__*/memo(_ref2 => {
  let {
    accept,
    multiple,
    onFiles,
    isBusy,
    children,
    controlComponent: ControlComponent,
    ...props
  } = _ref2;
  const idRef = React.useRef(dateid());
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ControlComponent, _extends({
    as: "label",
    htmlFor: idRef.current,
    busy: isBusy
  }, props), children), /*#__PURE__*/React.createElement("input", {
    id: idRef.current,
    type: "file",
    onChange: evt => handleChange(evt, onFiles),
    multiple: multiple,
    style: {
      display: 'none'
    },
    accept: accept,
    disabled: isBusy
  }));
});
FileInputButton.propTypes = {
  ...Button.propTypes,
  onFiles: PropTypes.func.isRequired,
  isBusy: PropTypes.bool
};
FileInputButton.defaultProps = {
  controlComponent: Button,
  multiple: false
};
FileInputButton.displayName = 'FileInputButton';
export default FileInputButton;